import React, { Component } from 'react'
import axios from 'axios';
import uniqueId from 'lodash.uniqueid';
import { debounce } from '../../utils';

const Autocomplete = ({ items, getItemValue, onSelect, onChange, value, inputProps }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const handleInputChange = (event) => {
        onChange(event);
    };

    const handleInputBlur = (event) => {
        if (!event.relatedTarget) {
            setIsOpen(false);
        }
    };

    const handleOnSelect = (value) => {
        onSelect(value);
    };

    return (
        <div
            tabindex="0"
            onBlur={handleInputBlur}
            onFocus={() => setIsOpen(true)}
            className='autocomplete'
        >
            <input
                type="text"
                value={value}
                onChange={handleInputChange}
                {...inputProps}
            />
            {isOpen && items.length
                ? <ul className="ui-autocomplete">
                    {items.map((item) => (
                        item.header
                            ? <li
                                className="autocomplete-list-header"
                                key={item.header}
                            >
                                {item.header}
                            </li>
                            : <li
                                className="autocomplete-list-item"
                                key={item.id}
                                onClick={() => handleOnSelect(getItemValue(item))}
                            >
                                <a href={item.url}>{getItemValue(item)}</a>
                            </li>
                    )
                    )}
                </ul>
                : null}
        </div>
    );
};

// ToDo:
// Loading spinner?
// absolute paths
// Mobile overflow-hidden bug

export default class SearchAutocompleteRoot extends Component {
    constructor(props) {
        super(props);

        this.apiRootUrl = '/api/product/autocomplete';
        this.apiInterface = {
            categoryName: 'CategoryName',
            productName: 'Name',
            externalUrl: 'ExternalUrl'
        };

        this.dataAttributes = document.getElementById(this.props.dataAttributeOwnerId).dataset;
        this.selectElement = document.getElementById(this.props.categorySelectElementId);
        this.minCharacters = this.props.minCharacters;

        this.state = {
            searchTerm: this.dataAttributes.value,
            resultList: []
        };

        this.handleSearchTermChange = this.handleSearchTermChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.clearData = this.clearData.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.categorizeResults = this.categorizeResults.bind(this);
    }

    clearData() {
        this.setState({ resultList: [] });
    }

    fetchData(searchTerm) {
        const currentCategory = this.selectElement.options[this.selectElement.selectedIndex].value;
        axios.get(this.apiRootUrl, {
            params: {
                term: searchTerm,
                categoryId: currentCategory,
                mockResults: false
            }
        })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                console.log(error.config);
            })
            .then(response => {
                this.setState({ resultList: this.categorizeResults(response.data.Items) });
            });
    }

    categorizeResults(resultArray) {
        let currentCategory = '';
        const apiInterface = this.apiInterface;

        return resultArray.reduce(function (accumulator, item) {
            if (item[apiInterface.categoryName] !== currentCategory) {
                accumulator.push({ header: item[apiInterface.categoryName] });
                currentCategory = item[apiInterface.categoryName];
            }
            accumulator.push({
                id: uniqueId(),
                name: item[apiInterface.productName],
                url: item[apiInterface.externalUrl]
            });
            return accumulator;
        }, []);
    }



    debounceFetchData = debounce(value => this.fetchData(value), 500)

    handleSearchTermChange(e) {
        const value = e.target.value;
        this.setState({ searchTerm: value });
        if (value !== '' && value.length >= this.minCharacters) {
            this.debounceFetchData(value);
        } else {
            this.clearData();
        }
    }

    handleSelect(value) {
        this.setState({ searchTerm: value, resultList: [] });
    }

    render() {
        return (
            <Autocomplete
                inputProps={{
                    id: this.dataAttributes.id,
                    className: this.dataAttributes.class,
                    type: this.dataAttributes.type,
                    name: this.dataAttributes.name,
                    placeholder: this.dataAttributes.placeholder,
                    autocomplete: 'off'
                }}
                value={this.state.searchTerm}
                items={this.state.resultList}
                getItemValue={(item) => item.name}
                onSelect={this.handleSelect}
                onChange={this.handleSearchTermChange}
            />
        )
    }
}
